import styled from 'styled-components';
import { colors, typography, spacing, borderRadius, shadows, breakpoints } from '../../styles/theme';

export const Grid = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${spacing.lg};
  max-width: 800px;
  margin: 0 auto;
`;

export const Combo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${spacing.sm};
  flex-wrap: wrap;

  @media (max-width: ${breakpoints.md}) {
    flex-direction: column;
    gap: ${spacing.sm};
  }
`;

export const ComboChip = styled.span`
  padding: 0.625rem 1.25rem;
  border-radius: ${borderRadius.full};
  background: ${colors.neutral.white};
  border: 1.5px solid ${colors.primary.teal};
  color: ${colors.primary.teal};
  font-size: ${typography.fontSize.base};
  font-weight: ${typography.fontWeight.bold};
  box-shadow: ${shadows.sm};
  text-align: center;
`;

export const PlusBadge = styled.span`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${borderRadius.full};
  background: ${colors.gradients.orange};
  color: ${colors.neutral.white};
  font-size: ${typography.fontSize.lg};
  font-weight: ${typography.fontWeight.extrabold};
  box-shadow: ${shadows.orange};
  flex-shrink: 0;
`;
